<template>
  <standard-dialog
    v-model="model"
    :title="$t('edit_contract') + ' ' + (contract.contract_number || '')"
    icon="mdi-file-document-edit-outline"
    :max-width="480"
    :disabled="saving"
    :loading="saving"
    @save="save"
  >
    <text-field v-model="form.contract_number" :label="$t('contract_number')" required :rules="[rules.required]" />

    <text-field
      :value="localeDate(contract.valid_from)"
      :label="$t('contract_valid_from')"
      disabled
      hide-details
    />
    <div class="caption grey--text mb-3">
      {{ $t("contract_items", { count: contract.broj_usluga }) }}
    </div>

    <date-picker
      v-model="form.valid_to"
      single-date
      :label="$t('contract_valid_to')"
      :min="contract.valid_from || contract.contract_date"
      :disabled="form.no_end_date"
    />
    <v-checkbox v-model="form.no_end_date" :label="$t('contract_no_end_date')" hide-details dense class="mt-0 mb-2" />

    <text-field v-model="form.document_url" :label="$t('contract_document_link')" />
    <text-area v-model="form.note" :label="$t('note')" rows="2" />
  </standard-dialog>
</template>

<script>
import StandardDialog from "@/components/dialogs/StandardDialog.vue";
import hasModel from "@/mixins/hasModel";
import hasValidation from "@/mixins/hasValidation";
import hasSnackbar from "@/mixins/hasSnackbar";
import contractsService from "@/services/contracts";

export default {
  name: "ContractEditDialog",
  mixins: [hasModel, hasValidation, hasSnackbar],
  components: {
    StandardDialog,
  },
  props: {
    restaurantId: {
      type: [Number, String],
      required: true,
    },
    contract: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      saving: false,
      form: {
        contract_number: "",
        valid_to: "",
        no_end_date: false,
        document_url: "",
        note: "",
      },
    };
  },
  watch: {
    model(val) {
      if (val) this.resetForm();
    },
  },
  methods: {
    resetForm() {
      this.form = {
        contract_number: this.contract.contract_number || "",
        valid_to: this.contract.valid_to || "",
        no_end_date: !this.contract.valid_to,
        document_url: this.contract.document_url || "",
        note: this.contract.note || "",
      };
    },
    async save() {
      if (!this.form.contract_number) {
        this.showErrorSnackbar(this.$t("please_fix_errors"));
        return;
      }
      this.saving = true;
      try {
        const payload = {
          contract_number: this.form.contract_number,
          valid_to: this.form.no_end_date ? null : this.form.valid_to || null,
          document_url: this.form.document_url || null,
          note: this.form.note || null,
        };
        const { data } = await contractsService.updateRestaurantContract(
          this.restaurantId,
          this.contract.id,
          payload
        );
        this.showSuccessSnackbar(data.message || this.$t("contract_updated_successfully"));
        this.$emit("saved", data);
        this.model = false;
      } catch (error) {
        this.showErrorSnackbar(this.$t("error_saving_contract"));
      } finally {
        this.saving = false;
      }
    },
  },
};
</script>
